(function() {
	'use strict';

	angular.module('smb-app')
		.directive('smbLogin', LoginDirective)
		.controller('smbLoginController', [
			'gettextCatalog',
			LoginController
		]);

	var templateUrl = require('./login.template');
	/**
	 * @ngdoc directive
	 * @name smb-app.smbLogin
	 * @module smb-app
	 * @restrict E
	 * @description
	 *
	 * @usage
	 *
	 * <smb-login />
	 */
	function LoginDirective() {
		return {
			restrict: 'E',
			controller: 'smbLoginController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: { }
		};
	}

	function LoginController(gettextCatalog) {
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/login/login.js
// module id = 93
// module chunks = 1